module.exports = __webpack_public_path__ + "static/media/dp1.bd0253b0.svg";